// extracted by mini-css-extract-plugin
module.exports =  {"button":"_13c3691929--button--wvpRY","dark":"_13c3691929--dark--HdtBl"};